var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 15.6904C4.93 15.6904 3.25 14.0104 3.25 11.9404C3.25 9.87043 4.93 8.19043 7 8.19043C9.07 8.19043 10.75 9.87043 10.75 11.9404C10.75 14.0104 9.07 15.6904 7 15.6904ZM7 10.1904C6.04 10.1904 5.25 10.9804 5.25 11.9404C5.25 12.9004 6.04 13.6904 7 13.6904C7.96 13.6904 8.75 12.9004 8.75 11.9404C8.75 10.9804 7.96 10.1904 7 10.1904Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.50977C14.93 9.50977 13.25 7.82977 13.25 5.75977C13.25 3.68977 14.93 2.00977 17 2.00977C19.07 2.00977 20.75 3.68977 20.75 5.75977C20.75 7.82977 19.07 9.50977 17 9.50977ZM17 4.00977C16.04 4.00977 15.25 4.79977 15.25 5.75977C15.25 6.71977 16.04 7.50977 17 7.50977C17.96 7.50977 18.75 6.71977 18.75 5.75977C18.75 4.79977 17.96 4.00977 17 4.00977Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22C14.93 22 13.25 20.32 13.25 18.25C13.25 16.18 14.93 14.5 17 14.5C19.07 14.5 20.75 16.18 20.75 18.25C20.75 20.32 19.07 22 17 22ZM17 16.5C16.04 16.5 15.25 17.29 15.25 18.25C15.25 19.21 16.04 20 17 20C17.96 20 18.75 19.21 18.75 18.25C18.75 17.29 17.96 16.5 17 16.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35003 11.4896C9.03003 11.4896 8.72003 11.3396 8.52003 11.0596C8.21003 10.5996 8.32002 9.97963 8.78002 9.66963L13.95 6.11963C14.41 5.80963 15.03 5.91963 15.34 6.37963C15.65 6.83963 15.54 7.45963 15.08 7.76963L9.91002 11.3196C9.74002 11.4396 9.54003 11.4996 9.34003 11.4996L9.35003 11.4896Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6301 17.8602C14.4401 17.8602 14.2601 17.8102 14.0901 17.7002L8.77005 14.2702C8.31005 13.9702 8.17005 13.3502 8.47005 12.8902C8.77005 12.4302 9.39005 12.2902 9.85005 12.5902L15.1701 16.0202C15.6301 16.3202 15.7701 16.9402 15.4701 17.4002C15.2801 17.7002 14.9601 17.8602 14.6301 17.8602Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBank);
export default __webpack_public_path__ + "static/media/ShareBank.3c59ad5bdf6ed90cd045aaf94be02b88.svg";
export { ForwardRef as ReactComponent };